import { Validateable } from "@models/interfaces";

export class OptOutTermsSlider extends Validateable {
	public sell_terms: boolean = false;

	public wiggleSell(): void {
		this.wiggle("sell_terms");
	}
}
